module.exports = __webpack_public_path__ + "media/images/area/area_sagaM400-bfda2e9e0babd13ea01054e6142f097b.jpg";